import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ChatProvider } from './context/ChatContext';
import { MemoryProvider } from './context/MemoryContext';
import { ThemeProvider, useTheme } from './context/ThemeContext';
import { lazyLoad } from './utils/lazyLoad';
import { BASE_PATH } from './config';
import './styles/global.css';
import { ConfigProvider, theme as antTheme } from 'antd';

// 使用懒加载替代直接导入
const LoginPage = lazyLoad(() => import('./pages/LoginPage'));
const HomePage = lazyLoad(() => import('./pages/HomePage'));

// 加载指示器组件
const LoadingIndicator = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <div>加载中，请稍候...</div>
  </div>
);

/**
 * 应用内容组件 - 根据登录状态渲染不同内容
 */
const AppContent = () => {
  const { isAuthenticated } = useAuth();

  return (
    <React.Suspense fallback={<LoadingIndicator />}>
      <Routes>
        <Route path="/login" element={
          <ThemeProvider>
            <ThemeConfigProvider>
              <LoginPage />
            </ThemeConfigProvider>
          </ThemeProvider>
        } />
        <Route 
          path="/" 
          element={
            isAuthenticated ? (
              <ThemeProvider>
                <ThemeConfigProvider>
                  <ChatProvider>
                    <MemoryProvider>
                      <HomePage />
                    </MemoryProvider>
                  </ChatProvider>
                </ThemeConfigProvider>
              </ThemeProvider>
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </React.Suspense>
  );
};

/**
 * 主题配置组件 - 为Ant Design组件提供主题支持
 */
const ThemeConfigProvider = ({ children }) => {
  const { isDarkMode } = useTheme();
  
  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkMode ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
      }}
    >
      {children}
    </ConfigProvider>
  );
};

/**
 * 应用入口组件
 */
const App = () => {
  console.log('应用基础路径:', BASE_PATH);
  
  return (
    <Router basename={BASE_PATH}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App; 